import { useEffect, useState } from 'react';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';

type Ask = {
  title: string;
  description: string;
  confirmLabel?: string;
  run: () => void;
};

let openAsk: ((ask: Ask) => void) | null = null;

/** Opens the shell confirm sheet. The action runs only after the operator confirms. */
export function askConfirm(ask: Ask) {
  openAsk?.(ask);
}

export function ConfirmHost() {
  const [pending, setPending] = useState<Ask | null>(null);
  useEffect(() => {
    openAsk = setPending;
    return () => {
      if (openAsk === setPending) openAsk = null;
    };
  }, []);
  return (
    <ConfirmDialog
      open={pending != null}
      onClose={() => setPending(null)}
      onConfirm={() => pending?.run()}
      title={pending?.title ?? ''}
      description={pending?.description ?? ''}
      confirmLabel={pending?.confirmLabel ?? pending?.title}
      danger
    />
  );
}
